import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import careers from "../About/about-img/careers.jpg";
import contact from "../About/about-img/contact.jpg";

const Other = () => {
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");

    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
        setFr(false);
      }
    }
  }, []);
  return (
    <>
      <div>
        <div class="wrapper" id="cover">
          <img
            src={require("../../Assets/vision2.png")}
            class="prx"
            style={{ height: "205px", width: "100%" }}
          />
          <h1>
            {rtl
              ? "رؤيتنا وقيمنا"
              : fr
              ? "NOTRE VISION NOS VALEURS"
              : `Our Vision Our Values`}
          </h1>
        </div>
      </div>
      {/* ********************** */}
      <div id="bodycont" class="bg">
        <div class="pagewrap">
          <div class="wrapper grid5">
            <article class="fluid animated fadeInRight">
              <div class="col">
                <div class="left-nav">
                  <ul>
                    <li>
                      <Link to="/about">
                        {rtl
                          ? "مكة والمدينة القابضة المحدودة"
                          : fr
                          ? "Mecque & la Médine Holding LTD"
                          : `Makkah & Al Madinah Holding LTD`}
                      </Link>
                    </li>
                    <li>
                      <Link to="/founder">
                        {rtl
                          ? " رسالة المؤسس"
                          : fr
                          ? "Message du fondateur"
                          : `Founder's Message`}
                      </Link>
                    </li>
                    {/* <li>
                                            <strong>Chairman Biography</strong>
                                            <p>
                                                <a
                                                    href="https://www.docdroid.net/9ZXCsYG/mmh-pdf"
                                                    target="_blank"
                                                >
                                                    English PDF
                                                </a>
                                            </p>
                                        </li> */}
                  </ul>
                </div>

                <div class="sidelight white">
                  <h2>
                    {" "}
                    {rtl
                      ? "وظائف مكة والمدينة القابضة المحدودة"
                      : fr
                      ? "CARRIÈRES MMH"
                      : "MMH Careers"}
                  </h2>
                  <img src={careers} class="crv2" />
                  <p>
                    {rtl
                      ? `تقدم وظائف مكة والمدينة القابضة المحدودة
 فرصا وظيفية مثيرة في جميع أنحاء العالم.`
                      : fr
                      ? `MMH offre des opportunités de carrière
                      passionnantes à travers le monde.`
                      : `MMH offers exciting career opportunities
                                        across the world.`}
                  </p>
                  <p>&nbsp;</p>
                  <Link to="/careers">
                    <p class="button2">
                      {rtl
                        ? "التعرف على المزيد"
                        : fr
                        ? "En savoir plus"
                        : "Learn More"}
                    </p>
                  </Link>
                </div>
              </div>
            </article>
            <article class="fluid two animated fadeInDown">
              <div class="col">
                <h1>
                  {rtl
                    ? `رؤيتنا ورسالتنا وقيمنا`
                    : fr
                    ? "NOTRE VISION, NOTRE MISSION ET NOS VALEURS"
                    : `Our Vision, Mission And Values`}
                </h1>
                <p
                  style={{
                    background: "white",
                    padding: "12px 15px 15px",
                  }}
                >
                  {rtl
                    ? `هدف مكة  والمدينة القابضة  هو البقاء دائما في طليعة المنحنى ، واستكشاف أحدث الابتكارات والتقنيات المتطورة في القطاعات التي اخترناها. يلتزم موظفونا بالحفاظ على هذه المعايير العالية ومكانة مكة  والمدينة القابضة    كشركة رائدة في الصناعة وصاحب العمل المفضل.`
                    : fr
                    ? `L'objectif de MMH est de toujours rester à l'avant-garde, en explorant les dernières innovations et
                    les technologies de pointe dans les secteurs que nous avons choisis. Notre personnel s'engage à
                    maintenir ces normes élevées et la position de MMH en tant que leader de l'industrie et employeur
                    de choix.`
                    : `MMH’s objective is to always stay ahead of
                                    the curve, exploring the latest innovations
                                    and cutting edge technologies in our chosen
                                    sectors. Our people are committed to
                                    maintaining these high standards and MMH’s
                                    position as an industry leader and employer
                                    of choice.`}
                </p>
                <p>&nbsp;</p>
                <p
                  style={{
                    background: "white",
                    padding: "12px 15px 15px",
                  }}
                >
                  {rtl
                    ? `هدفنا هو توفير بيئة عمل مثيرة ومليئة بالتحديات للأشخاص الأذكياء والموهوبين. يتم تدريب موظفينا على إيجاد حلول مبتكرة للتحديات الأكثر تعقيدا لعملائنا. إنهم يعتمدون على قيمنا الأساسية المتمثلة في تقديم خدمة احترافية ، والحفاظ على الاحترام المتبادل وروح الفريق ، وتشجيع المبادرة والابتكار ، وامتلاك تصميم لا هوادة فيه على النجاح.`
                    : fr
                    ? `Notre objectif est d'offrir un environnement de travail passionnant et stimulant à des personnes
                    brillantes et talentueuses. Nos employés sont formés pour trouver des solutions créatives aux défis
                    les plus complexes de nos clients. Ils s'appuient sur nos valeurs fondamentales : fournir un service
                    professionnel, maintenir le respect mutuel et l'esprit d'équipe, encourager l'initiative et
                    l'innovation, et faire preuve d'une détermination sans faille pour réussir.`
                    : `Our aim is to provide an exciting and
                                    challenging work environment for bright and
                                    talented people. Our employees are trained
                                    to find creative solutions to our customers’
                                    most complex challenges. They draw on our
                                    core values of delivering professional
                                    service, maintaining mutual respect and team
                                    spirit, encouraging initiative and
                                    innovation, and having an unrelenting
                                    determination to succeed.`}
                </p>
                <p>&nbsp;</p>

                <p>&nbsp;</p>

                <h3>{rtl ? `رؤيتنا` : fr ? "NOTRE VISION" : `Our Vision`}</h3>
                <div class="center-box">
                  <p class="mtb">
                    {rtl
                      ? `تتضمن رؤية السيد سيدي شيهد فلسفاته الشخصية كرجل أعمال إسلامي يرغب في تعزيز البرامج المفيدة اجتماعيا القائمة على "المساعدة والمشاركة والرعاية". إن مساعدة الجيران، ومشاركة الطعام والمأوى مع المحتاجين، ورعاية العائلة والأصدقاء والأحباء هي المبادئ التي توجه حياة سيدي الشخصية ومساعيه المهنية.`
                      : fr
                      ? `La vision de M. Sidi Shahid intègre ses philosophies personnelles en tant qu'homme d'affaires
                      islamique qui souhaite promouvoir des programmes socialement bénéfiques basés sur "l'aide, le
                      partage et l'attention". Aider ses voisins, partager la nourriture et le logement avec ceux qui sont
                      dans le besoin, et prendre soin de sa famille, de ses amis et de ses proches sont les principes qui
                      guident la vie personnelle et les activités professionnelles de M. Sidi.`
                      : `Mr. Sidi Shahid vision incorporates his
                                        personal philosophies as an Islamic
                                        businessman who wishes to promote
                                        socially beneficial programs based upon
                                        “helping, sharing and caring.” Helping
                                        one’s neighbors, sharing food and
                                        shelter with those in need, and caring
                                        for family, friends and loved ones are
                                        the principles which guide Sidi’s
                                        personal life and professional pursuits.`}
                  </p>
                </div>

                <h3>
                  {rtl ? `رسالتنا` : fr ? "NOTRE MISSION" : `Our Mission`}
                </h3>
                <div class="center-box">
                  <p class="mtb">
                    {rtl
                      ? `لتجاوز التوقعات`
                      : fr
                      ? "Dépasser les attentes"
                      : `To Exceed Expectations`}
                  </p>
                </div>

                <h3>{rtl ? `قيمنا` : fr ? "NOS VALEURS" : `Our Values`}</h3>
                <div class="center-box">
                  <ul class="pad-ul mtb">
                    <li>
                      {rtl
                        ? `إدارة الأعمال بنزاهة`
                        : fr
                        ? "Faire des affaires avec intégrité"
                        : `Conduct Business with Integrity`}
                    </li>
                    <li>
                      {rtl
                        ? `نسعى جاهدين لتحقيق التميز التشغيلي`
                        : fr
                        ? "Viser l'excellence opérationnelle"
                        : `Strive for Operational Excellence`}
                    </li>
                    <li>
                      {rtl
                        ? `تلبية احتياجات عملائنا`
                        : fr
                        ? "Répondre aux besoins de nos clients"
                        : `Fulfill our Clients’ Needs`}
                    </li>
                    <li>
                      {rtl
                        ? `احتضان التغيير الإيجابي`
                        : fr
                        ? "Accepter les changements positifs"
                        : `Embrace Positive Change`}
                    </li>
                  </ul>
                </div>

                <p>&nbsp;</p>
                <p>&nbsp;</p>
              </div>
            </article>
            <article class="fluid animated fadeInLeft">
              <div class="col">
                <h3 style={{ textAlign: "center" }}>
                  {rtl ? "اتصل بنا" : fr ? "Nous Contacter" : "Contact Us"}
                </h3>
                <div class="right-box">
                  <Link to="/contact-us">
                    <img src={contact} />
                  </Link>
                  <p style={{ textAlign: "center" }}>
                    {rtl
                      ? `للاتصال بنا عبر البريد الإلكتروني ، ما عليك سوى ملء النموذج أدناه.
`
                      : fr
                      ? "Pour nous contacter par email, il suffit de remplir le formulaire ci-dessous."
                      : `To contact us by email, simply fill
                                            in the form below.`}{" "}
                    <br />
                    <Link to="/contact-us">
                      {rtl
                        ? "اقرأ المزيد..."
                        : fr
                        ? "Lire la suite..."
                        : "Read More..."}
                    </Link>
                  </p>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </>
  );
};

export default Other;
